<div class="main">
  <div class="btn-area">
    <button *ngIf="!auth.isYakuin" type="button" class="delete" (click)="onDelete()">{{'delete' | translate}}</button>
    <div class="btn-area__right">
      <button type="button" (click)="onClose()" class="cancel">{{ 'cancel' | translate }}</button>
      <button *ngIf="!auth.isYakuin" type="submit" class="submit" form="company-edit-form">{{ 'save' | translate }}</button>
    </div>
  </div>
  <div class="header">
    <h1>{{'editCompany' | translate}}</h1>
  </div>
  <hr class="styled-line">
  <br>
  <form id="company-edit-form" [formGroup]="companyForm" (ngSubmit)="onSubmit()" autocomplete="off">
    <section class="scrollable-section">
      <div class="content">
        <div class="label-class">{{'companyInformation' | translate}}</div>   
        <div class="field-class">
          <div class="required-fields">
            <span class="field-label">*{{'companyName' | translate}}</span>
            <input type="text" class="input-field" matInput id="name" formControlName="name" [placeholder]="'enterCompanyName' | translate">
            <div *ngIf="companyForm.get('name')?.invalid && companyForm.get('name')?.touched" class="error-message">
              <div *ngIf="companyForm.get('name')?.hasError('required')">{{ "fieldRequired" | translate }}</div>
            </div>
          </div>
        </div>
        <div class="field-class">
          <span class="field-label">{{'japaneseCompanyOtherName' | translate}}</span>
          <input type="text" class="input-field" matInput id="otherName" [placeholder]="'enterJapaneseName' | translate" formControlName="otherName">
        </div>  
        <div class="field-class">
          <span class="field-label">{{'ceo' | translate}}</span>
          <input type="text" class="input-field" matInput id="ceo" [placeholder]="'enterCeoName' | translate" formControlName="ceo">
        </div>  
        <div class="field-class">
          <span class="field-label">{{'email' | translate}}</span>
          <input type="text" class="input-field" matInput required id="email" placeholder="example@email.com" formControlName="email">
          <div *ngIf="companyForm.get('email')?.invalid && companyForm.get('email')?.touched" class="error-message">
            <div *ngIf="companyForm.get('email')?.hasError('required')">{{ "fieldRequired" | translate }}</div>
          </div>
        </div>  
        <div class="field-class">
          <div class="subgrid-container">
            <div>
              <span class="field-label">{{'phone' | translate}}</span>
              <input type="text" class="custom-input-sub" matInput id="telephone" placeholder="(+01)-0000-0000" formControlName="telephone"> 
            </div>
            <div>       
              <span class="field-label">{{'fax' | translate}}</span>
              <input type="text" class="custom-input-sub" matInput id="fax" [placeholder]="'enterFaxNumber' | translate" formControlName="fax">
            </div>
          </div>
        </div>
        <div class="field-class">
          <div class="flex flex-row mb-6">
            <div>
              <input type="checkbox" class="h-5 w-5 mr-3" id="isGlobalReadable" [checked]="companyForm!.value.isGlobalReadable" (change)="onGlobalReadableChange($event)">
            </div>
            <div class="label-column">
              <label class="container" for="isGlobalReadable">{{ 'isGlobalReadable' | translate}}</label>
            </div>
          </div>
        </div>
        <div class="field-class">
          <mat-label class="field-label" formControlName="types" multiple ngDefaultControl>*{{ "types" | translate }}</mat-label> 
          <div class="check-boxes" *ngFor="let companyType of companyTypes">
            <div class="checkbox-column">
              <input type="checkbox" class="check" id="{{companyType.value}}" [name]=companyType.display [value]= companyType.value [checked]="companyForm.get(companyType.value)?.value == 1" (change)="onChange($event)">
            </div>
            <div class="label-column">
              <label class="container" for="{{companyType.value}}">{{ companyType.display | translate }}</label>
            </div>
          </div>
        </div>
        <hr class="styled-line">
        <label class="label-class">{{'companyAddress' | translate}}</label>
        <div class="field-class">
          <span class="field-label">{{ "addressLine1" | translate }}</span>
          <input type="text" class="input-field" matInput id="Address Line 1" [placeholder]="'enterStreetAddress' | translate" formControlName="address">
        </div>  
        <div class="field-class">
          <span class="field-label">{{'addressLine2' | translate}}</span>
          <input type="text" class="input-field" matInput id="address2" [placeholder]="'apartmentOptional' | translate" formControlName="addressLineTwo">
        </div> 
        <div class="field-class">
          <div class="subgrid-container">
            <div style="display: flex;flex-direction: column;">
              <span class="field-label">{{'city' | translate}}</span>
              <input type="text" class="custom-input-sub" matInput id="city" [placeholder]="'enterCity' | translate" formControlName="city"> 
            </div>
            <div>       
              <span class="field-label">{{'zipCode' | translate}}</span>
              <input type="text" class="custom-input-sub" matInput id="zip" [placeholder]="'enterZipCode' | translate" formControlName="zipCode">
            </div>
          </div>
        </div>
        <div class="field-class">
          <span class="field-label">{{'country' | translate}}</span>
          <input type="text" class="input-field" matInput id="country" [placeholder]="'enterCountry' | translate" formControlName="country">
        </div>        
      </div>
    </section>
  </form>
</div>
    